export default "__VITE_ASSET__74f7595f__$_?component__"